import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import React, { useEffect, useState } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { Auth } from 'aws-amplify';
import { dateFormat, EPISODE_STS_ALERT_URL } from '../../../../constants';
import { useDispatch, useSelector } from 'react-redux';
import { getStopApi } from '../../../../services/StopApi/StopApi';
import moment from 'moment';
import {
  getStaAlertForm,
  newStsAlert,
} from '../../../../redux/episode/stsAlertTab/stsAlertForm';
import FormInputRadio from '../../../common/Forms/FormRadio';
import StsAlertDialog from './StsAlertDialog';
import {
  DataGridContainer,
  GridContainer,
  LeftGrid,
  NoteHeading,
} from '../../Episode.Styled';

function StsAlert() {
  const dispatch = useDispatch();
  const [stsAlertForm, setStsAlertForm] = useState({
    isLoading: false,
    data: [],
    pageSize: 10,
    total: 0,
    page: 1,
  });
  const [open, setOpen] = useState(false);
  const [user, setUser] = useState(null);
  const [openBackdrop, setOpenBackdrop] = useState(false);
  const episodeId = useSelector(
    (state) => state?.episodeDetail?.singleEpisode[0]?.episodeId
  );

  useEffect(() => {
    if (user?.signInUserSession.accessToken.jwtToken) {
      fetchData();
    }
    getUser().then((userData) => setUser(userData));
  }, [
    user?.signInUserSession.accessToken.jwtToken,
    stsAlertForm.page,
    stsAlertForm.pageSize,
  ]);

  const fetchData = async () => {
    setStsAlertForm((prveState) => ({ ...prveState, isLoading: true }));
    const commonParams = `${EPISODE_STS_ALERT_URL}/${episodeId}/alertList?PageNumber=${stsAlertForm.page}&PageSize=${stsAlertForm.pageSize}`;
    const authorization = `${user?.signInUserSession.accessToken.jwtToken}`;
    getStopApi({ commonParams, authorization }).then((response) => {
      const json = response.data;
      setStsAlertForm((prveState) => ({
        ...prveState,
        isLoading: false,
        total: response.totalRows,
        data: json?.map((item, index) => ({
          ...item,
          id: index,
          alertID: item.alertID ? item.alertID : '-',
          alertDate: item.alertDate
            ? moment(item.alertDate).format(dateFormat).split('T')[0]
            : '-',
        })),
      }));
    }).catch((e) => alert(e));
    // const stsTabUrl = `${EPISODE_STS_ALERT_URL}/${episodeId}`;
    // dispatch(getStaAlertForm({ stsTabUrl, authorization }));
  };

  const getUser = () => {
    return Auth.currentAuthenticatedUser()
      .then((userData) => userData)
      .catch(() => console.log('Not signed in'));
  };

  const stsAlertRowClick = (rowData) => {
    const stsTabUrl = `${EPISODE_STS_ALERT_URL}/${rowData.alertID}`;
    const authorization = `${user?.signInUserSession.accessToken.jwtToken}`;
    setOpenBackdrop(true);
    setTimeout(() => {
      setOpenBackdrop(false);
    }, 700);
    dispatch(getStaAlertForm({ stsTabUrl, authorization }));
    setOpen(true);
  };

  const openNewStsAlert = () => {
    const newStsAlertPayload = {
      newStsAlert: true,
      alertID: 0,
      altEditCntId: '',
      alertAptType: '',
      alertDate: '',
      missedAppointmentOn: '',
      altDsc: '',
      comment: '',
      altFlagYN: '',
      altInactiveYN: '',
      alertCreatedDate: '',
      alertEditedDate: '',
      altCbpOrgID: '',
      admittedToProgramOn: '',
      dichargedFromProgramOn: '',
      admissionMode: '',
      dischargeMode: '',
      altCbpCntID: '',
      dischargeReason: '',
      alertDischOthRsn: '',
      alertAptTypOth: '',
      altCreateCntId: '',
      alertAthType: '',
      urinalysisFor: '',
      alertUADate: '',
      emergencyMedicalCareAt: '',
      alertEmerCareDate: '',
      BehavioralOrTreatmentCaseConference: '',
      cbpProgram: '',
      cbpContact: '',
      statusAlertCreatedBy: '',
      editedBy: '',
    };
    dispatch(newStsAlert(newStsAlertPayload));
    setOpen(true);
  };

  const columnsData = [
    {
      field: 'allAlerts',
      headerName: 'All Alerts',
      sortable: false,
      flex: 1,
      minWidth: 80,
    },
    {
      field: 'alertID',
      headerName: 'Alert ID',
      sortable: false,
      flex: 1,
      minWidth: 80,
    },
    {
      field: 'alertDate',
      headerName: 'Alert Date',
      sortable: false,
      flex: 1,
      type: 'date',
      minWidth: 80,
    },
  ];
  return (
    <>
      <GridContainer container>
        <Grid item xs={6}>
          <NoteHeading variant='h5'>
            To edit sts alert please click on particular row
          </NoteHeading>
        </Grid>
        <LeftGrid item xs={6}>
          <Button variant='contained' onClick={() => openNewStsAlert()}>
            New Sts Alert
          </Button>
        </LeftGrid>
      </GridContainer>
      <DataGridContainer>
      <div style={{ height: 670, width: '100%' }}>
        <div style={{ display: 'flex', height: '100%' }}>
          <div style={{ flexGrow: 1 }}>
            <DataGrid
              getRowHeight={() => 'auto'}
              columns={columnsData}
              rows={stsAlertForm.data}
              rowCount={stsAlertForm.total}
              rowsPerPageOptions={[10, 25, 50]}
              pageSize={stsAlertForm.pageSize}
              pagination
              paginationMode='server'
              getRowClassName={(params) =>
                params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
              }
              onPageSizeChange={(newPageSize) =>
                setStsAlertForm((old) => ({ ...old, pageSize: newPageSize }))
              }
              onPageChange={(newPage) => {
                setStsAlertForm((old) => ({ ...old, page: newPage + 1 }));
              }}
              loading={stsAlertForm.isLoading}
              onRowClick={(param) => stsAlertRowClick(param.row)}
              disableColumnFilter
              disableColumnMenu
            />
          </div>
        </div>
      </div>      
      </DataGridContainer>
      <StsAlertDialog
        open={open}
        setOpen={setOpen}
        authToken={user?.signInUserSession.accessToken.jwtToken}
        episodeId={episodeId}
        openBackdrop={openBackdrop}
        fetchData={fetchData}
      />
    </>
  );
}

export default StsAlert;
